const Configuracion = 
  {
    proyecto: "afirmehipotecario",
    aplicacion:"AFIRME-HIPOTECARIO",
    version: "1.2.2",
    derechos:"POWER BY © SINESTRY 2025",
    basedatos:"siniestrosapdb",
    mensajesplash:"",
    author:"Ing.Juan Carlos Arreola Lopez",
    urlapi://' ttp://localhost:4001',
            'https://sinestrydev-552789706120.us-central1.run.app',
  };
export default Configuracion;

